import React,{Component} from 'react';
import { NavLink } from 'react-router-dom';



class Privacy extends React.Component {

    componentWillMount () {
        
        const script = document.createElement("script");
     
        script.src = "/assets/js/menutoggle.js";
       
        script.async = true;
     
        document.body.appendChild(script);
       
      }

      constructor(props) {
		super(props);
		this.state = {
            opened: false,
            closed:true
		};
		this.toggleBox = this.toggleBox.bind(this);
	}
  
	toggleBox() {
        const { opened } = this.state;
        const { closed } = this.state;
		this.setState({
            opened: !opened,
            closed: !closed
		});
    }
      
      render(){
        const { opened } = this.state;
        const { closed } = this.state;
 
        return(
            <div class="privacypageupperdiv  page-create-account ">
            <div class="main-banner companybg newonetop pri thissignup">
        
                <div class="container">
                
                <header class="main-header d-flex justify-content-between">
               <div class="site-logo">
                  
                 
                  <a href="/">
                      <img src="/assets/images/P-Icon_black.png" class="desklogo signupbl" />
                  </a>
                
               </div>
               
            </header>
                
            </div> </div> 
    
            <section class="sectionBuilder hero --feature-callout -first">
    <div class="container -full">
        <div class="row -center hero-row">
            <div class="signupForm-homepage-center col-xsmall-12 col-small-8 col-small-offset-2 col-medium-10 col-medium-offset-1 col-large-8 col-large-offset-2 col-xlarge-6 col-xlarge-offset-3">
                <h4 class="heading -spacing-2 -h3">Sign up</h4>
                 {closed && (
                    <p></p>
                     )}
                         {opened && (
                <p class="c76075b34 c2fad6637 error-message">Sorry this email isn't part of the Beta Access Whitelist.</p>
                )}
                
                <form  class="signupForm hidden-logged-in signupForm-homepage-center" >
                    <div class="signupForm-container">
                        <div class="signupForm-row">
                        <div class="form-group">
                                
                                <input type="email"  required="required"  class="form-control" placeholder="name@email.com" id="work-email" />
                            </div>

                            <div class="submit-btn">
                                <div id="go-to-nextStep"  onClick={this.toggleBox} class="btn btn-lg btn-flat btn-block btn-primary">Next</div>
                            </div>
                        </div>
                    </div>
                </form>
                <p class="subheading -spacing-1 hero-legal-copy hj">
                    By signing up, I agree to the Workpoint <a href="#" class="css-1kfjk3x-Link">Privacy Policy</a> and <a href="#" class="css-1kfjk3x-Link">Terms</a>.
                </p>
            </div>
        </div>
        <div class="row -ta-center page-aside-row">
            <div>
                <div class="feature-callout">
                   
                    <h2
                        class="feature-callout__header"
                        data-gtm-vis-recent-on-screen-6076898_224="1739"
                        data-gtm-vis-first-on-screen-6076898_224="1739"
                        data-gtm-vis-total-visible-time-6076898_224="100"
                        data-gtm-vis-has-fired-6076898_224="1"
                    >
                        Your plan includes
                    </h2>
                    <div class="feature-callout__list list">
                        <div class="list__icon"><img src="https://luna1.co/dec30d.png" alt="check icon" width="22" /></div>
                        <p class="list__item">New Buyer Intent Notifications</p>
                        <div class="list__icon"><img src="https://luna1.co/dec30d.png" alt="check icon" width="22" /></div>
                        <p class="list__item">Deep Buyer Insights </p>
                        <div class="list__icon"><img src="https://luna1.co/dec30d.png" alt="check icon" width="22" /></div>
                        <p class="list__item">Integrate into your existing CRM</p>
                        <div class="list__icon"><img width="18" /></div>
                        <p class="list__item">Plus much more...</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

       
       </div>
        );
    }
}

export default Privacy;